import { jsxs as l, jsx as C } from "react/jsx-runtime";
const e = ({
  width: o,
  height: r,
  className: t
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 15 12",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M12.4575 3.74894C11.9727 3.26602 11.5254 2.82013 11.0781 2.37424C10.9538 2.25 10.8249 2.12997 10.7068 2.00009C10.4245 1.69018 10.4358 1.26399 10.7279 0.973293C11.0195 0.683069 11.4588 0.662908 11.7542 0.955476C12.7744 1.96493 13.7872 2.98189 14.7985 4.00025C15.0123 4.21546 15.0456 4.47427 14.9466 4.76402C14.8449 5.06128 14.64 5.2085 14.3395 5.24226C14.2701 5.25023 14.1993 5.25163 14.129 5.2521C10.7077 5.2521 7.28689 5.25304 3.86563 5.2507C3.7381 5.2507 3.60588 5.24085 3.48444 5.20522C3.14452 5.10582 2.95557 4.77152 3.0048 4.38565C3.05075 4.0251 3.30722 3.78035 3.67058 3.75222C3.74654 3.7466 3.82296 3.74894 3.89892 3.74894C6.66378 3.74894 9.42864 3.74894 12.194 3.74894C12.2629 3.74894 12.3323 3.74894 12.457 3.74894H12.4575Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M2.54686 8.25001C3.14137 8.84265 3.70025 9.39403 4.2521 9.95197C4.58546 10.2895 4.58218 10.7312 4.25773 11.0425C3.96516 11.3229 3.54178 11.3276 3.24593 11.0421C2.9257 10.7326 2.61484 10.4138 2.29977 10.0992C1.61617 9.41559 0.93117 8.73387 0.249918 8.04793C-0.0660934 7.73004 -0.081097 7.35167 0.197405 7.00894C0.340408 6.83312 0.528889 6.75435 0.750191 6.74825C0.896475 6.74403 1.04323 6.74638 1.18951 6.74638C4.48184 6.74638 7.77464 6.74638 11.067 6.74638C11.1256 6.74638 11.1842 6.74497 11.2428 6.74685C11.7159 6.76232 12.0061 7.05395 12.0019 7.50874C11.9981 7.96213 11.7018 8.2486 11.224 8.24907C8.41792 8.25048 5.61179 8.25001 2.8052 8.25001H2.54686Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  e as Content
};
